// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"d6f68a9443ce0fc1fea0","544":"78fb78d00045fc5d8717"}[chunkId] + ".js";
};